/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadStatusRuleConditionGroupPayloadFromJSON, ApiLeadStatusRuleConditionGroupPayloadToJSON, } from './ApiLeadStatusRuleConditionGroupPayload';
import { ApiLeadStatusTypeFromJSON, ApiLeadStatusTypeToJSON, } from './ApiLeadStatusType';
export function ApiLeadStatusRulePayloadFromJSON(json) {
    return ApiLeadStatusRulePayloadFromJSONTyped(json, false);
}
export function ApiLeadStatusRulePayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asDefault': !exists(json, 'asDefault') ? undefined : json['asDefault'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'rules': !exists(json, 'rules') ? undefined : (json['rules'].map(ApiLeadStatusRuleConditionGroupPayloadFromJSON)),
        'stageKey': !exists(json, 'stageKey') ? undefined : json['stageKey'],
        'stageOrder': !exists(json, 'stageOrder') ? undefined : json['stageOrder'],
        'type': !exists(json, 'type') ? undefined : ApiLeadStatusTypeFromJSON(json['type']),
    };
}
export function ApiLeadStatusRulePayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asDefault': value.asDefault,
        'name': value.name,
        'rules': value.rules === undefined ? undefined : (value.rules.map(ApiLeadStatusRuleConditionGroupPayloadToJSON)),
        'stageKey': value.stageKey,
        'stageOrder': value.stageOrder,
        'type': ApiLeadStatusTypeToJSON(value.type),
    };
}
